import React, { useState } from 'react';

import { createStyles, Paper, Title } from '@mantine/core';
import ClassTypeMultiSelectAutoComplete, {
  IEventTypeMultiSelectAutoComplete,
} from 'components/form-fields/auto-complete-fields/EventTypeMultiSelectAutoComplete';

import { FilterTerms } from './types';

const useStyles = createStyles(theme => ({
  header: {
    padding: theme.spacing.lg,
    paddingBottom: 0,
    background: theme.colors.gray[0],
    borderRadius: 0,
    display: 'grid',
    gridTemplateColumns: 'auto max-content',
    gridTemplateRows: 'auto',
    gridTemplateAreas: `"title search"`,
    alignItems: 'center',
    gap: theme.spacing.sm,
    [theme.fn.smallerThan('sm')]: {
      gridTemplateColumns: 'auto',
      gridTemplateRows: 'auto',
      gridTemplateAreas: `
        'title'
        'search'
      `,
    },
  },
  title: {
    gridArea: 'title',
  },
  search: {
    gridArea: 'search',
  },
}));

interface ProgramsHeaderProps {
  initialSearchFiltersValue: FilterTerms;
  setSearchFilters: React.Dispatch<React.SetStateAction<FilterTerms>>;
}

const ProgramsPageHeader = ({ setSearchFilters }: ProgramsHeaderProps): JSX.Element => {
  const { classes } = useStyles();

  const [kiloClassTypes, setKiloClassTypes] = useState<IEventTypeMultiSelectAutoComplete[]>([]);

  const handleKiloClassTypeChange = (values: IEventTypeMultiSelectAutoComplete[]): void => {
    setKiloClassTypes(values);
    setSearchFilters(prev => ({ ...prev, kiloClassTypes: values.map(v => v.eventTypeId) }));
  };

  return (
    <Paper className={classes.header}>
      <Title order={1} size='h1' pr='xl' className={classes.title}>
        Programming
      </Title>
      <ClassTypeMultiSelectAutoComplete
        handleChange={handleKiloClassTypeChange}
        values={kiloClassTypes}
        className={classes.search}
        data-cy='programmingTableContainer'
      />
    </Paper>
  );
};

export default ProgramsPageHeader;
